import { VTextField } from 'vuetify/lib'
import { defaultFun } from '../utils'
import { INTEGER_FIELD } from '../type_name'
import commonMixins from './commonMixins'
export default {
    name: INTEGER_FIELD,
    mixins: [ commonMixins ],
    render(h) {
        const {
             // eslint-disable-next-line 
             slots,scopedSlots,
             key,
             blur = defaultFun,
             change = defaultFun,
             click = defaultFun,
             focus = defaultFun,
             input = defaultFun,
             keydown = defaultFun,
             mousedown = defaultFun,
             mouseup = defaultFun,
             ...params 
            } = this.field
        params.type = 'number'
        return h(VTextField, {
            slots: this.slots,
            scopedSlots:  this.separateSlot && this.separateSlot() || {},
            ref:'VTextField',
            props: {
                ...params,
                value: this.my_value[key]
            },
            on: {
                blur,
                change,
                click,
                focus,
                input:(data) => {
                    const index = data.indexOf('.')
                    if (index !== -1) {
                        data = data.slice(0, index)
                    }
                    this.my_value[key] = ['', null, undefined].includes(data) ? null : Number(data)
                    input(this.my_value)
                    if (index !== -1) { // hack
                     this.$refs.VTextField.lazyValue = this.my_value[key]
                    }
                },
                keydown,
                mousedown,
                mouseup
            }
        })
    }
}